import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-block content-block--separated property-additional-resources" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-4" }, " Resources ", -1)),
    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: resource.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: resource.resource_file,
                target: "_blank",
                class: "text-center property-additional-resources__link"
              }, _toDisplayString(resource.name), 9, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}